import { render, staticRenderFns } from "./CauseOfReduction.vue?vue&type=template&id=d2c408e2"
import script from "./CauseOfReduction.vue?vue&type=script&lang=js"
export * from "./CauseOfReduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports